const TAKE_PATH = /^\/take\/[a-fA-F0-9]{24}$/;

export function safePortalNext(search: string): string {
  const next = new URLSearchParams(search).get('next') || '';
  return TAKE_PATH.test(next) ? next : '/';
}

export function loginPathForPortal(pathname: string): string {
  if (TAKE_PATH.test(pathname)) {
    return `/login?next=${encodeURIComponent(pathname)}`;
  }
  return '/login';
}
